module.exports = __webpack_public_path__ + "img/payconiq.429d2385.svg";